<template>
    <div>

        <PageHeader>
            {{ $t('reportsShops2') }}
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonResetFilters @click="resetFilters()" />
                    <TimeRangeCalendar ref="TimeRangeCalendar" v-model="timeRange" compare-year />
                </div>
            </template>
        </PageHeader>

        <ImpressionsReport />

        <CampaignReport />

        <ImpressionsCampaignRanking />

    </div>
</template>



<script>
    import ButtonResetFilters from '@/components/common/ButtonResetFilters.vue';
    import TimeRangeCalendar from '@/components/common/TimeRangeCalendar.vue';
    import ImpressionsReport from './parts/ImpressionsReport.vue';
    import CampaignReport from './parts/CampaignReport.vue';
    import ImpressionsCampaignRanking from './parts/ImpressionsCampaignRanking.vue';

    export default {
        name: 'ReportsShops',
        components: {
            ButtonResetFilters,
            TimeRangeCalendar,
            ImpressionsReport,
            CampaignReport,
            ImpressionsCampaignRanking,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                timeRange: null,
            };
        },
        methods: {
            resetFilters() {
                this.$emit('resetFilters');
                this.$refs.TimeRangeCalendar.resetDate();
            },
        },
    };
</script>
